import { render, staticRenderFns } from "./shopInformation.vue?vue&type=template&id=64cfea1e&scoped=true"
import script from "./shopInformation.vue?vue&type=script&lang=js"
export * from "./shopInformation.vue?vue&type=script&lang=js"
import style0 from "./shopInformation.vue?vue&type=style&index=0&id=64cfea1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cfea1e",
  null
  
)

export default component.exports